module.exports = __webpack_public_path__ + "static/tat-27-b963843c0be5af1d696ae2c024d28c67.jpg";